// 用户管理模块 
export const userRouter = [
  //  个人账号列表
  {
    path: '/user/personalList',
    name: 'personalList',
    component: () => import('../views/user/personalList')
  },
   {
    path: '/user/accountLogout',
    name: 'accountLogout',
    component: () => import('../views/user/accountLogout')
  }
];